var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-notification',{attrs:{"type":_vm.notification.type,"value":_vm.notification.status},on:{"input":function($event){return _vm.setNotification({ status: false })}}},[_vm._v(" "+_vm._s(_vm.notification.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }